import Overview from "./Overview";
import DocumentsAndContact from "./DocumentsAndContact";
import DrugCoverage from "../DrugCoverage";
import Navigation from "./Navigation";
import StarRatings from "./StarRatings";

export default {
  Overview,
  DrugCoverage,
  DocumentsAndContact,
  Navigation,
  StarRatings,
};
